export function withTimeout<T>(p: Promise<T>, ms: number, fallback: T): Promise<T> {
  let t: any;
  const timeout = new Promise<T>(resolve => t = setTimeout(() => resolve(fallback), ms));
  return Promise.race([p, timeout]).finally(() => clearTimeout(t));
}